import { render, staticRenderFns } from "./lkuSalesCampaign.vue?vue&type=template&id=2c03d05a"
import script from "./lkuSalesCampaign.vue?vue&type=script&lang=js"
export * from "./lkuSalesCampaign.vue?vue&type=script&lang=js"
import style0 from "./lkuSalesCampaign.vue?vue&type=style&index=0&id=2c03d05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports